import styled from "styled-components";

export const LottieAnimationContainer = styled.div`
  width: 100%;
  height: 100%;
  z-index: 1;
  position: absolute;
  pointer-events: none;
`;
